import { Build } from "@stencil/core"

export const setupLoggers = () => {
  if (!Build.isDev) {
    globalThis.ds = {
      log: () => {
        return
      },
      warn: () => {
        return
      },
      info: () => {
        return
      },
    }
  } else {
    const dsLog = (...args: any[]) => {
      console.log(...args)
    }
    const dsWarn = (...args: any[]) => {
      console.warn(...args)
    }

    const dsInfo = (...args: any[]) => {
      console.warn(...args)
    }

    globalThis.ds = {
      log: dsLog,
      warn: dsWarn,
      info: dsInfo,
    }
  }
}
